import styled from 'styled-components'

export const Value = styled.p`
  font-size: 0.75rem;
  line-height: 0.9375rem;
  font-weight: bold;
  color: ${(props) => props.theme.colors.feedback.success.A500};
`
